export enum FlexDirections {
    row = 'row',
    rowReverse = 'row-reverse',
    column = 'column',
    columnReverse = 'column-reverse',
}
